import React from 'react';
import CursiveToPrint from './cursiveToPrint';

const AppsTabPage = () => (
  <div style={{ paddingTop: 80, paddingLeft: 1 }}>
    <CursiveToPrint />
  </div>
);

export default AppsTabPage;
